import { Box, Button, Grid, Typography } from '@mui/material';
import DemandMetricGroup from './DemandMetricGroup';
import DemandMetricGroupSkeleton from './DemandMetricGroupSkeleton';
import DemandOverviewActions from './DemandOverviewActions';

function DemandOverviewContent({ groups, isLoading, onCreate, onListView, onMetricOpen }) {
  if (!isLoading && groups.length === 0) {
    return (
      <Box className="sas-content-empty">
        <Typography
          variant="subtitle2"
          className="sas-content-empty-title">
          No data is available yet
        </Typography>
        <>
          <Typography
            variant="body2"
            className="sas-content-empty-copy">
            Click &quot;Create&quot; to create your first deal and get started.
          </Typography>
          <Button
            variant="contained"
            onClick={onCreate}
            className="sas-content-empty-button">
            CREATE
          </Button>
        </>
      </Box>
    );
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{ alignItems: 'center' }}>
      <Grid size={{ xs: 12, lg: 10 }}>
        <Grid
          container
          spacing={2}>
          {groups.map(group => (
            <Grid
              key={group.id}
              size={{ xs: 12, sm: 6, md: group.metrics.length > 1 ? 4 : 2 }}>
              {isLoading ? (
                <DemandMetricGroupSkeleton metricCount={group.metrics.length} />
              ) : (
                <DemandMetricGroup
                  group={group}
                  onOpen={onMetricOpen}
                />
              )}
            </Grid>
          ))}
        </Grid>
      </Grid>

      <Grid size={{ xs: 12, lg: 2 }}>
        <DemandOverviewActions
          onCreate={onCreate}
          onListView={onListView}
        />
      </Grid>
    </Grid>
  );
}

export default DemandOverviewContent;
